import LLGlobeTrotter from '@/locales/GlobeTrotter/fr';
import LLTrendingNow from '@/locales/TrendingNow/fr';
import LLEdito from '@/locales/Edito/fr';
import LLTravel from '@/locales/Travel/fr';
import LLTune from '@/locales/Tune/fr';
import LLFuture from '@/locales/Future/fr';
import LLArtyWilmotte from '@/locales/ArtyWilmotte/fr';
import LLArtyMirror from '@/locales/ArtyMirror/fr';
import LLKeyReport from '@/locales/KeyReport/fr';
import LLEntrepreneurs from '@/locales/Entrepreneurs/fr';
import LLEssential from '@/locales/Essential/fr';
import LLWayISeeIt from '@/locales/WayISeeIt/fr';
import LLLegal from '@/locales/Legal/fr';

export const  fr = {

    // les éléments du menu
    // pour l'edito, vu qu'il est variable en fonction du marché (present dans l'url), la structure est un peu différente
    menu: {
        EditoEN: {
            segment: 'edito',
            title: 'Édito',
        },
        EditoMC: {
            segment: 'edito',
            title: 'Édito',
        },
        EditoCH: {
            segment: 'edito',
            title: 'Édito',
        },
        EditoLU: {
            segment: 'edito',
            title: 'Édito',
        },
        EditoUK: {
            segment: 'edito',
            title: 'Édito',
        },
        EditoFR: {
            segment: 'edito',
            title: 'Édito',
        },
        Essential: {
            segment: 'les-essentiels',
            title: 'Les essentiels',
        },
        WayISeeIt: {
            segment: 'eclairage',
            title: 'L’éclairage',
        },
        TrendingNow: {
            segment: 'tendances',
            title: 'Tendances',
        },
        GlobeTrotter: {
            segment: 'planete-insolite',
            title: 'Planète insolite',
        },
        Travel: {
            segment: 'le-comte-galway',
            title: 'Le comté de Galway',
        },
        Tune: {
            segment: 'pari-esthetique-christophe-rousset',
            title: 'Le pari esthétique de Christophe Rousset',
        },
        Future: {
            segment: 'vers-frugalite-heureuse',
            title: 'Vers une frugalité heureuse ?',
        },
        ArtyMirror: {
            segment: 'de-lautre-cote-du-miroir-valerie-belin',
            title: 'De l’autre côté du miroir, de Valérie Belin',
        },
        ArtyWilmotte: {
            segment: 'le-monde-de-jean-michel-wilmotte',
            title: 'Le monde de Jean-Michel Wilmotte',
        },
        KeyReport: {
            segment: 'le-plastique-bientot-detrone',
            title: 'Le plastique bientôt détrôné ?',
        },
        Entrepreneurs: {
            segment: 'christine-vernay-femme-de-terroir',
            title: 'Christine Vernay, une femme de terroir',
        },
        Legal: {
            segment: 'credits-informations-legales',
            title: 'Credits & informations légales',
        },

    },

    // les différentes pages, on scinde en fichiers, sinon ca va être trop long et chiant a contribuer

    Essential: LLEssential,

    EditoEN: LLEdito,
    EditoMC: LLEdito,
    EditoCH: LLEdito,
    EditoLU: LLEdito,
    EditoUK: LLEdito,
    EditoFR: LLEdito,

    TrendingNow: LLTrendingNow,

    GlobeTrotter: LLGlobeTrotter,

    Travel: LLTravel,
    Tune: LLTune,

    Future: LLFuture,

    ArtyWilmotte: LLArtyWilmotte,
    ArtyMirror: LLArtyMirror,

    KeyReport: LLKeyReport,

    Entrepreneurs: LLEntrepreneurs,

    WayISeeIt: LLWayISeeIt,

    Legal: LLLegal,

    home: {
        logoBaseLine: 'Voir le monde différemment&nbsp;avec <br />Société&nbsp;Générale Private&nbsp;Banking <br/>Été 2020 #4',
        title: 'Christine Vernay, une femme de terroir',
        artitle1title: 'Ils pensent le futur',
        artitle1content: 'Innovation frugale et low-tech, des pistes pour faire mieux avec moins',
        artitle2title: 'Le grand dossier',
        artitle2content:  'Le plastique bientôt détrôné?',
        artitle3title: 'Voyager différemment',
        artitle3content:  'Le comté de Galway en tous sens, avec Jérôme Galland',
    },

    next: 'À suivre : ',

    welcome_message : 'FR - Welcome to Your Vue.js App',
    popular_links : 'FR - Popular Links',
    ecosystem : 'FR - Ecosystem',
    test: {
        toto: 'toto label',
        tutu: 'tutu label',
        titi: {
            test: 'titi label',
        },
    },
    counterUpSeparator: ',',
    counterUpDecimal: '.',
};
